import React, { useEffect, useState } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import i18n from 'i18n-react';
import logo from 'assets/images/logo/logo.png';
import DataTable from 'react-data-table-component';
import BookingState from './BookingState';
import { storageKeys, baseAppId } from 'settings';

import { RewardMenu, APIHandler, StorageHandler, ContentHeader, DataHandler } from 'C4';

const getBookings = async (callback) => {
  try {
    StorageHandler.load(storageKeys.accessToken).then((token) => {
      DataHandler.matchAppId().then((appId) => {
        APIHandler.getRewards(appId, token).then((res) => {
          const bookings = res.response?.map((item) => {
            const booking = {
              ...item,
              reservation_number: item.reservation_number,
              status: item.status,
              departure_date: item.departure_date,
              agent_last_name: item.agent_last_name,
              number_of_guests: item.number_of_guests,
              length_of_stay: item.length_of_stay,
            };
            return booking;
          });
          callback(bookings);
        });
      })
    });
  } catch (error) {
    console.log(error);
  }
};

const BookingsView = () => {
  const [bookings, setBookings] = useState([]);
  const [show, setShow] = useState({});
  const [points, setPoints] = useState({});
  const [activeBtn, setActiveBtn] = useState('View All');

  useEffect(() => {
    if (bookings.length === 0) {
      getBookings((data) => {
        setBookings(data);
        setShow({
          showKey: 'View All',
          'View All': true,
          data: [...data],
        });
      });
    }
    if (!(points.total >= 0)) {
      StorageHandler.load(storageKeys.accessToken).then((token) => {
        const startDate = '2021-07-21';
        const endDate = '2022-12-21';
        APIHandler.getPoints(baseAppId, startDate, endDate, token).then((res) => {
          setPoints(res.total);
        });
      });
    }
  }, [bookings, points, setBookings, setShow, setPoints]);

  const columns = [
    {
      name: i18n.translate('rewards.bookingsView.columns.reservationNumber'),
      selector: (row) => row.reservation_number,
      sortable: true,
    },
    {
      name: i18n.translate('rewards.bookingsView.columns.status'),
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: i18n.translate('rewards.bookingsView.columns.firstName'),
      selector: (row) => row.agent_first_name,
      sortable: true,
      hide: 'sm',
    },
    {
      name: i18n.translate('rewards.bookingsView.columns.numberOfGuests'),
      selector: (row) => row.number_of_guests,
      sortable: true,
    },
    {
      name: i18n.translate('rewards.bookingsView.columns.lengthOfStay'),
      selector: (row) => row.length_of_stay,
      sortable: true,
      hide: 'md',
    },
  ];
  const paginationComponentOptions = {
    rowsPerPageText: i18n.translate('rewards.bookingsView.rowsPerPage'),
    rangeSeparatorText: i18n.translate('rewards.bookingsView.rangeSeparator'),
    noRowsPerPage: false,
    selectAllRowsItem: true,
    selectAllRowsItemText: i18n.translate('rewards.bookingsView.selectAllRowsItem'),
  };

  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get('mobile')) {
    mobile = true;
  }

  return (
    <div className="contentContainer bookingsView">
      <RewardMenu />
      <div className="header">
        <ContentHeader
          header={i18n.translate('rewards.bookingsView.title')}
          subtitle={i18n.translate('rewards.bookingsView.subtitle')}
        />
      </div>
      <hr />
      <div className="bookingsHolder">
        <div className="tableNav">
          {Object.entries(BookingState)
            .sort(([, valueA], [, valueB]) => valueB - valueA)
            .map(([key]) => {
              const booking = bookings.filter(({ status }) => BookingState[key].status.includes(status));

              return (
                <div
                  key={key}
                  onClick={() => {
                    setActiveBtn(key);
                    setShow({
                      showKey: key,
                      [`${key}`]: true,
                      data: booking.length > 0 ? [...booking] : [],
                    });
                  }}
                  aria-hidden
                >
                  <button className={activeBtn === key ? 'btn active' : 'btn'}>
                    {key === 'Confirmed Entries' && <FontAwesomeIcon icon={['fas', 'check']} />}
                    {key === 'Pending Entries' && <FontAwesomeIcon icon={['fas', 'clock']} />}
                    {key === 'Rejected Entries' && <FontAwesomeIcon icon={['fas', 'ban']} />}
                    {key === 'View All' && <FontAwesomeIcon icon={['fas', 'th-list']} />}

                    <span>{booking.length}</span>
                    <span
                      className="head"
                      dangerouslySetInnerHTML={{
                        __html: i18n
                          .translate(`rewards.bookingsView.statusCategories.${key.toLowerCase().replace(' ', '')}`)
                          .replace(' ', '<br/>'),
                      }}
                    ></span>
                  </button>
                </div>
              );
            })}
        </div>

        <ContentHeader
          header={i18n.translate('rewards.bookingsView.manage')}
          subtitle={i18n.translate('rewards.bookingsView.manageSub')}
        />

        <div className="table-booking">
          <DataTable
            className="bookings-table"
            columns={columns}
            data={show.data}
            defaultSortFieldId={1}
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 15]}
            paginationComponentOptions={paginationComponentOptions}
            noDataComponent={(<div className='bookings-table__no-data-component'>{i18n.translate('rewards.bookingsView.noBookings')}</div>)}
          />
        </div>
        <RewardMenu />
      </div>

      {mobile && (
        <style>
          {
            '\
      #CookiebotWidget { display: none !important; } .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }'
          }
        </style>
      )}
    </div>
  );
};

export default BookingsView;
